<template>
<div>

  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <button @click="updateItem" class="btn btn-sm btn-warning btn-icon">
          <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
    </button>
  </div>
  <br/>
  <br/>
  <hr/>
  <group-course :id="id"/>
</div>

</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import GroupCourse from '@/components/Item/Group/GroupCourse';
export default {
  components:{
    GroupCourse
  },
  data: () => ({
    cardLink: "business/groups",
    cardSetLink: "business/groups",
    item: null,
    fields: [
          {
            col:'col-12 col-sm-4 col-md-3 col-lg-2',
            key: "locale",
            label: "Локализация класса",
            type: "locale",
          },
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
